import { loadStripe, type Stripe } from "@stripe/stripe-js";

// Single shared promise. Resolves to a Stripe instance, or null if either:
//   1. VITE_STRIPE_PUBLIC_KEY is missing from the bundle, or
//   2. js.stripe.com failed to load (most commonly user-side ad-blocker /
//      privacy extension blocking Stripe). Without this catch, the rejection
//      bubbles to window.onunhandledrejection and gets reported to Sentry as
//      a real bug, even though it's a user-environment issue we can't fix.
//      Pages should branch on the resolved value and render a friendly
//      "browser is blocking the payment processor" UI.
export const stripePromise: Promise<Stripe | null> | null = import.meta.env.VITE_STRIPE_PUBLIC_KEY
  ? loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY).catch((err) => {
      console.warn("[stripe] failed to load Stripe.js, likely blocked client-side:", err?.message || err);
      return null;
    })
  : null;
